<template lang="pug">
.ui_icon(
  :class='getCssClass',
  v-bind='$attrs',
  v-on='$listeners',
  :style='getStyle'
)
  component.ui_icon__template(:is='template')
</template>

<script>
/**
 * дока по иконкам http://localhost:3000/uikit/icons
 * */
export default {
  props: {
    /** шаблон свгшки, прям сам компонент, а не строка */
    template: {
      required: true,
    },
    /** ширина вручную, если указано игнорирует size ширину */
    manualWidth: {
      type: String,
    },
    /** высота вручную, если указано игнорирует size высоту */
    manualHeight: {
      type: String,
    },
    /**  все иконки имеют разную прорисовку, поэтому цвет можно по разному задавать,
     * методом тыка подобрать нужный
     * цвет наследуется от AppSvgIcon(class="my-color") */
    colorMode: {
      type: String,
      default: 'none',
      validator: (val) => ['none', 'fill', 'stroke', 'multi', 'hidden_fill'].includes(val),
    },
    /** указать один из дефолтных размеров */
    size: {
      type: String,
      default: 'small',
      validator: (val) => ['xsmall', 'small', 'medium', 'large', 'auto', '100'].includes(val),
    },
    /** поведение как у кноки, стили ховер */
    AsIsButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getCssClass() {
      return {
        [`ui_icon_size__${this.size}`]: true,
        ['is_btn']: this.AsIsButton,
        'color-mode_fill': this.colorMode === 'fill',
        'color-mode_stroke': this.colorMode === 'stroke',
        'color-mode_multi': this.colorMode === 'multi',
        'color-mode_hidden_fill': this.colorMode === 'hidden_fill',
      };
    },
    getStyle() {
      return {
        ...(this.manualWidth && { width: this.manualWidth }),
        ...(this.manualHeight && { height: this.manualHeight }),
      };
    },
  },
};
</script>

<style lang="stylus">
@import '~@/uikit/stylus/index'

.is_btn{
  opacity: .8;
  //transition: .5s linear;
  transform: scale(0.95);
  cursor pointer
  &:hover{
    opacity: 1;
    transform: scale(1);
  }
}
.ui_icon{
  display: flex;
  align-items: center;
  justify-content: center;
  /** если что можно обернуть врапером что бы патчи свгшки не генерили моусовер события*/
  //.wrap{
  //  background: transparent;
  //  z-index: 0;
  //  position: absolute;
  //  height: 100%;
  //  width: 100%;
  //  top: 0;
  //}

  &__template{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 99% !important;
    width: 99% !important;
  }

}
.ui_icon_size__xsmall {
  height 12px
  width 12px
}
.ui_icon_size__small{
  height 18px
  width 18px
}
.ui_icon_size__medium{
  height 25px
  width 25px
}
.ui_icon_size__large{
  height 30px
  width 30px
}
.ui_icon_size__100{
  height 100%
  width 100%
}
.ui_icon_size__auto{
  height auto
  width auto
}
.color-mode_hidden_fill {
  svg * {
    fill: none !important;
  }
  //svg circle {
  //  fill: currentcolor;
  //}
}
.color-mode_fill {
  svg * {
    fill: currentcolor !important;
    stroke: unset !important;
  }
  //svg circle {
  //  fill: currentcolor;
  //}
}
.color-mode_stroke {
  svg * {
    stroke: currentcolor !important;
    fill: unset !important;
  }
}
.color-mode_multi {
  svg * {
    fill: currentcolor !important;
    stroke: currentcolor !important;
  }
}
</style>



// WEBPACK FOOTER //
// AppSvgIcon.vue?7a010aab